import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { AdPlacementPreview } from '@bingads-webui-campaign-react/ad-placement-preview';
import { ImageExperienceImage } from '../model/image-experience-image';
import C from '../constants';

import './preview.less';

export class PreviewGeneral extends React.PureComponent {
  render() {
    const aspectRatios = C.getAspectRatios({
      isMultimediaAd: this.props.isMultimediaAd,
      isCombinedMsanAndMmaAspectRatios: this.props.isCombinedMsanAndMmaAspectRatios,
      isMMAV2Enabled: this.props.isMMAV2Enabled,
      isBoost200x100ImageEnabled: this.props.isBoost200x100ImageEnabled,
      isBoostNewAspectRatioSupportEnabled: this.props.isBoostNewAspectRatioSupportEnabled,
      isStoreAppProng: this.props.isStoreAppProng,
      isStoreAppSpotLight: this.props.isStoreAppSpotLight,
      isStoreAppTransparentLogo: this.props.isStoreAppTransparentLogo,
      isPMaxAspectRatiosV2Enabled: this.props.isPMaxAspectRatiosV2Enabled,
    });

    let aspectRatioSettings = aspectRatios[this.props.image.Type];

    if (this.props.customAspectRatioSettings) {
      aspectRatioSettings = this.props.customAspectRatioSettings || aspectRatioSettings;
    }
    const additionalSetting = _.defaults({
      aspectRatio: aspectRatioSettings.aspectRatio,
    }, this.props.additionalSetting || {
      previewTypeStringKey: aspectRatioSettings.previewTypeStringKey,
      imagePreviewHeight: aspectRatioSettings.imagePreviewHeight,
      logoHeight: aspectRatioSettings.logoHeight,
    });
    const placementPreviewProps = _.extend({}, _.pick(
      this.props,
      'image',
      'previewTexts',
      'i18n',
      'showShortHeadline',
      'showLongHeadline',
      'showDescription',
      'showGradient',
      'opacityChangeEnabled',
      'previewContentClassName',
      'showBusinessName',
      'showAdsIcon',
      'showUrl',
      'showAction',
      'showAdsLabel',
      'multipleDescription',
      'multipleLineLongHeadline',
      'hideLabel',
      'logo',
      'hotspots',
      'showHotspots',
      'showImage',
      'dismissText',
      'showLogo',
      'isMultimediaAd',
      'isMultiMediaAdsPhase2Enabled',
      'isAdCreatorEnabled'
    ), {
      additionalSetting,
    });

    return (
      <AdPlacementPreview
        {...placementPreviewProps}
      >
        {
          this.props.showAdditionalDisclaimer && !this.props.isMultiMediaAdsPhase2Enabled &&
          <div className="additional-disclaimer">
            {this.props.i18n.getString(this.props.isMultimediaAd ? 'ImageExperience_Additional_Disclaimer_Message_MultimediaAd' : 'ImageExperience_Additional_Disclaimer_Message')}
          </div>
        }
      </AdPlacementPreview>
    );
  }
}

PreviewGeneral.propTypes = {
  image: PropTypes.instanceOf(ImageExperienceImage).isRequired,
  previewTexts: PropTypes.shape({
    shortHeadline: PropTypes.string,
    longHeadline: PropTypes.string,
    description: PropTypes.string,
    businessName: PropTypes.string,
    url: PropTypes.string,
    callToAction: PropTypes.string,
  }).isRequired,
  customAspectRatioSettings: PropTypes.shape({
    imagePreviewHeight: PropTypes.number,
  }),
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  showShortHeadline: PropTypes.bool,
  showLongHeadline: PropTypes.bool,
  showDescription: PropTypes.bool,
  showGradient: PropTypes.bool,
  showAdditionalDisclaimer: PropTypes.bool,
  previewContentClassName: PropTypes.string.isRequired,
  additionalSetting: PropTypes.shape({
    previewTypeStringKey: PropTypes.string,
    imagePreviewHeight: PropTypes.number,
  }),
  showBusinessName: PropTypes.bool,
  showUrl: PropTypes.bool,
  showAction: PropTypes.bool,
  opacityChangeEnabled: PropTypes.bool,
  showAdsLabel: PropTypes.bool,
  isMultimediaAd: PropTypes.bool,
  isMultiMediaAdsPhase2Enabled: PropTypes.bool,
  isCombinedMsanAndMmaAspectRatios: PropTypes.bool,
  isAdCreatorEnabled: PropTypes.bool,
  isMMAV2Enabled: PropTypes.bool,
  isBoost200x100ImageEnabled: PropTypes.bool,
  isBoostNewAspectRatioSupportEnabled: PropTypes.bool,
  isStoreAppProng: PropTypes.bool,
  isStoreAppSpotLight: PropTypes.bool,
  isStoreAppTransparentLogo: PropTypes.bool,
  isPMaxAspectRatiosV2Enabled: PropTypes.bool,
};

PreviewGeneral.defaultProps = {
  showShortHeadline: false,
  opacityChangeEnabled: false,
  showLongHeadline: false,
  showDescription: false,
  showGradient: false,
  customAspectRatioSettings: null,
  showAdditionalDisclaimer: false,
  additionalSetting: null,
  showBusinessName: true,
  showUrl: false,
  showAction: false,
  showAdsLabel: false,
  isMultimediaAd: false,
  isMultiMediaAdsPhase2Enabled: false,
  isCombinedMsanAndMmaAspectRatios: false,
  isAdCreatorEnabled: false,
  isMMAV2Enabled: false,
  isBoost200x100ImageEnabled: false,
  isBoostNewAspectRatioSupportEnabled: false,
  isStoreAppProng: false,
  isStoreAppSpotLight: false,
  isStoreAppTransparentLogo: false,
  isPMaxAspectRatiosV2Enabled: false,
};
